import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, HStack, Icon, Span, Stack, Text, } from '@chakra-ui/react';
import { CategoryGrid } from '@client/components/collections/CategoryGrid';
import { ListingGrid } from '@client/components/collections/ListingGrid';
import { ShopGrid } from '@client/components/collections/ShopGrid';
import { AppError } from '@client/components/feedback/AppError';
import { InfoPageDialog } from '@client/components/richText/InfoPageDialog';
import { SectionTitle } from '@client/components/textDisplay/SectionTitle';
import { GRID_CONTENT_MAX_WIDTH, SECTION_TITLE_GAP, InfoPageKey, } from '@client/constants';
import { useApiClient } from '@client/hooks/useApiClient';
import { useMinDuration } from '@client/hooks/useMinDuration';
import { useCategories } from '@client/providers/CategoriesProvider';
import { displayFontFamily } from '@client/theme';
import { callApi } from '@client/utils/apiUtils';
import { useEffect, useState } from 'react';
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
export const LandingPage = () => {
    const [aboutOpen, setAboutOpen] = useState(false);
    const [shops, setShops] = useState([]);
    const [shopsLoading, setShopsLoading] = useState(false);
    const [shopsError, setShopsError] = useState(null);
    const [listings, setListings] = useState([]);
    const [listingShops, setListingShops] = useState([]);
    const [listingsLoading, setListingsLoading] = useState(false);
    const [listingsError, setListingsError] = useState(null);
    const { getChildCategories, categoriesLoading, categoriesError } = useCategories();
    const isLoading = useMinDuration(shopsLoading || listingsLoading || categoriesLoading);
    const showCategoriesLoading = useMinDuration(categoriesLoading);
    const apiClient = useApiClient();
    const loadShopData = async () => {
        const result = await callApi(apiClient.shops.getFeatured());
        if (result.error !== null) {
            setShopsError('Failed to load makers');
        }
        else {
            setShops(result.data);
        }
        setShopsLoading(false);
    };
    const loadListings = async () => {
        const result = await callApi(apiClient.listings.getAll());
        if (result.error !== null) {
            setListingsError('Failed to load listings');
        }
        else {
            setListings(result.data.listings);
            setListingShops(result.data.shops);
        }
        setListingsLoading(false);
    };
    useEffect(() => {
        setListingsLoading(true);
        setShopsLoading(true);
        setShopsError(null);
        setListingsError(null);
        loadShopData();
        loadListings();
    }, []);
    return (_jsxs(Stack, { gap: 10, pt: 7, px: 5, pb: 10, alignItems: "center", maxW: GRID_CONTENT_MAX_WIDTH, mx: "auto", children: [_jsxs(Stack, { gap: 0, children: [_jsxs(HStack, { fontFamily: displayFontFamily, fontSize: 28, fontWeight: 400, flexShrink: 0, children: ["Welcome to", _jsx(Span, { fontWeight: 500, children: "Heirloom.shop" })] }), _jsxs(Stack, { gap: 3, alignItems: "center", children: [_jsx(Text, { fontFamily: displayFontFamily, fontSize: 22, textAlign: "center", children: "An exhibition of craftsmanship" }), _jsxs(Button, { size: "sm", fontSize: 18, onClick: () => setAboutOpen(true), children: [_jsx(Icon, { as: FaArrowUpRightFromSquare, w: 3.5, h: 3.5 }), "Learn More"] })] })] }), categoriesError ? (_jsx(AppError, { title: "Failed to load categories" })) : (_jsx(Box, { width: "100%", children: _jsx(CategoryGrid, { categories: getChildCategories(null), isLoading: isLoading }) })), shopsError ? (_jsx(AppError, { title: "Failed to load makers" })) : (_jsxs(Stack, { gap: SECTION_TITLE_GAP, width: "100%", children: [_jsx(SectionTitle, { children: "Makers" }), _jsx(ShopGrid, { shops: shops, isLoading: isLoading })] })), listingsError ? (_jsx(AppError, { title: listingsError })) : (_jsxs(Stack, { gap: SECTION_TITLE_GAP, width: "100%", children: [_jsx(SectionTitle, { children: "Featured" }), _jsx(ListingGrid, { listings: listings, isLoading: isLoading, shops: listingShops })] })), _jsx(InfoPageDialog, { infoPageKey: InfoPageKey.ABOUT, open: aboutOpen, onClose: () => setAboutOpen(false) })] }));
};
